import React, { useState } from "react";
import api from "../../api/axios";

const UploadFileModal = ({ onClose, onSuccess }) => {
  const [form, setForm] = useState({
    filename: "",
    file_type: "pdf",
    file: null,
    link: "",
  });

  const [error, setError] = useState("");

  const MAX_SIZES = {
    pdf: 5 * 1024 * 1024,     
    image: 5 * 1024 * 1024,   
    zip: 15 * 1024 * 1024,   
  };

  const validateFile = () => {
    if (form.file_type === "link") return true;

    if (!form.file) {
      setError("Please select a file.");
      return false;
    }

    const maxSize = MAX_SIZES[form.file_type];

    if (form.file.size > maxSize) {
      setError(
        `${form.file_type.toUpperCase()} file size exceeds allowed limit`
      );
      return false;
    }

    return true;
  };

  const submit = async () => {
    setError("");

    if (!validateFile()) return;

    const data = new FormData();
    Object.keys(form).forEach((key) => {
      if (form[key]) data.append(key, form[key]);
    });

    await api.post("companyblog/admin/uploads/", data, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "multipart/form-data",
      },
    });

    onSuccess();
    onClose();
  };

  return (
    <>
      {/* MODAL CSS */}
      <style>
        {`
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.55);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 9999;
        }

        .modal-card {
          background: #fff;
          width: 480px;
          padding: 20px;
          border-radius: 8px;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);
        }

        .modal-card h3 {
          margin-bottom: 16px;
        }

        .modal-card input,
        .modal-card select {
          width: 100%;
          padding: 8px;
          margin-bottom: 12px;
          border: 1px solid #ccc;
          border-radius: 4px;
        }

        .error-text {
          color: #e63946;
          font-size: 13px;
          margin-bottom: 10px;
        }

        .modal-actions {
          display: flex;
          justify-content: flex-end;
          gap: 10px;
        }
        `}
      </style>

      <div className="modal-overlay">
        <div className="modal-card">
          <h3>Add File</h3>

          <input
            type="text"
            placeholder="Filename"
            value={form.filename}
            onChange={(e) =>
              setForm({ ...form, filename: e.target.value })
            }
          />

          <select
            value={form.file_type}
            onChange={(e) =>
              setForm({
                ...form,
                file_type: e.target.value,
                file: null,
                link: "",
              })
            }
          >
            <option value="pdf">PDF</option>
            <option value="image">Image</option>
            <option value="zip">ZIP</option>
            <option value="link">Link</option>
          </select>

          {form.file_type === "link" ? (
            <input
              type="text"
              placeholder="External Link"
              onChange={(e) =>
                setForm({ ...form, link: e.target.value })
              }
            />
          ) : (
            <input
              type="file"
              onChange={(e) =>
                setForm({ ...form, file: e.target.files[0] })
              }
            />
          )}

          {error && <div className="error-text">{error}</div>}

          <div className="modal-actions">
            <button onClick={onClose}>Close</button>
            <button className="btn-primary" onClick={submit}>
              Save
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default UploadFileModal;
